import { z } from 'zod';
import { ContractSchema } from './contract';

export const PromptVersionSchema = z.object({
  id: z.number(),
  version: z.number(),
  createdAt: z.number(),
  minTokens: z.number(),
  maxTokens: z.number(),
  additionalContentIds: z.array(z.string()).nullable(),
  text: z.string().optional(),
  model: z.string().optional(),
});
export type PromptVersion = z.infer<typeof PromptVersionSchema>;

export const PromptSchema = z.object({
  id: z.number(),
  name: z.string(),
  description: z.string().optional(),
  prompt: z.string().optional(),
  image: z.string().optional(),
  type: z.string().optional(),
  additionalContentIds: z.array(z.string()).optional(),
  published: z.number().optional(),
  lastUsed: z.number().optional(),
  createdAt: z.number().optional(),
  updatedAt: z.number().optional(),
  deletedAt: z.number().optional(),
  usageCount: z.number().optional(),
  contracts: z.array(ContractSchema).optional(),
  images: z.array(z.string()).optional(),
  videos: z.array(z.string()).optional(),
  gifs: z.array(z.string()).optional(),
  stickers: z.array(z.string()).optional(),
  animatedStickers: z.array(z.string()).optional(),
  thumbnails: z.array(z.string()),
  versions: z.array(PromptVersionSchema).optional(),
  version: z.number().optional(),
  minTokens: z.number().optional(),
  maxTokens: z.number().optional(),
  model: z.string().optional(),
  ownerId: z.string().optional(),
  latestContentUrl: z.string().optional(),
});
export type Prompt = z.infer<typeof PromptSchema>;

export const CompactPromptSchema = z.object({
  id: z.number(),
  name: z.string(),
});

export type CompactPrompt = z.infer<typeof CompactPromptSchema>;

export const VersionSchema = z.object({
  createdAt: z.number(),
  minTokens: z.number(),
  maxTokens: z.number(),
  id: z.number(),
  model: z.string(),
  text: z.string(),
  version: z.number(),
});
export type Version = z.infer<typeof VersionSchema>;

// Prompt Feedback
export const PromptFeedbackSchema = z.object({
  id: z.number(),
  prompt_version_id: z.number(),
  account_id: z.string(),
  sentiment: z.enum(['positive', 'negative']),
  content_reference_id: z.string(),
  feedback_text: z.string().nullable(),
  created_at: z.number(),
});

export type PromptFeedback = {
  id: number;
  promptVersionId: number;
  accountId: string;
  sentiment: 'positive' | 'negative';
  contentReferenceId: string;
  feedbackText: string | null;
  createdAt: number;
};

export type PromptFeedbackSentiment = 'positive' | 'negative';
